export const UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME = 'global-shortcuts-platform-component';
export const UFO_LOAD_HOLD_NAME = 'global-shortcuts-data-loading';
